var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhoPageCakeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5015 9.79651V10.6268C1.5015 11.6055 1.42125 11.958 2.613 11.958H9.2955C10.4865 11.958 10.4055 11.6048 10.4055 10.6268V9.79651H1.5015Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70125 2.25H3V4.554H3.70125V2.25Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25H5.25V4.47675H6V2.25Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9925 2.25H8.25V4.38825H8.9925V2.25Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72375 0.731111C3.79875 1.03561 3.68025 1.38586 3.396 1.41736C3.1305 1.44736 2.92725 1.10461 3.13125 0.764861C3.3405 0.419861 3.396 0.0448608 3.396 0.0448608C3.396 0.0448608 3.636 0.365111 3.72375 0.731111Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9535 0.765751C6.03225 1.08525 5.90775 1.45425 5.60175 1.48725C5.316 1.51875 5.09775 1.158 5.31825 0.80175C5.54325 0.438 5.60175 0.0442505 5.60175 0.0442505C5.60175 0.0442505 5.85825 0.38175 5.9535 0.765751Z",
    fill: "#757575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9805 0.767259C9.0645 1.08676 8.931 1.45426 8.607 1.48726C8.304 1.51876 8.0715 1.15876 8.30625 0.802509C8.5455 0.440259 8.607 0.0465088 8.607 0.0465088C8.607 0.0465088 8.87925 0.384009 8.9805 0.767259Z",
    fill: "#757575"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3595 6.32777C2.67075 6.32777 3.1215 6.03227 3.25425 5.92877C3.258 5.92427 3.7995 5.41577 4.45575 5.41577C5.109 5.41577 5.673 5.91977 5.69625 5.94152C5.81775 6.04652 6.21975 6.32777 6.57675 6.32777C6.99825 6.32777 7.40775 5.94902 7.40775 5.94902C7.43775 5.92052 7.998 5.41577 8.67375 5.41577C9.3525 5.41577 9.89325 5.92427 9.91575 5.94602C10.0365 6.04952 10.2638 6.20177 10.4685 6.27752C10.4453 5.30177 9.99675 4.52252 8.8365 4.52252H3.19425C2.151 4.52252 1.68075 5.15027 1.57875 5.98427C1.7475 6.10952 2.09475 6.32777 2.3595 6.32777Z",
    fill: "#757575"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53775 7.10177C9.52425 7.08977 9.12 6.71252 8.6745 6.71252C8.22525 6.71252 7.80075 7.09277 7.7955 7.09727C7.776 7.11452 7.23225 7.62227 6.5775 7.62227C5.92875 7.62227 5.34675 7.12202 5.322 7.10027C5.19975 6.99077 4.8105 6.71252 4.4565 6.71252C4.035 6.71252 3.6285 7.08977 3.62325 7.09277C3.537 7.16177 2.92425 7.62227 2.36025 7.62227C2.07075 7.62227 1.78125 7.50302 1.55775 7.37852V8.95877H10.4745V7.59827C10.0163 7.50302 9.59175 7.14752 9.53775 7.10177Z",
    fill: "#757575"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8882 10.5H0V11.9513H11.8882V10.5Z",
    fill: "#757575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoPageCakeIcon);
export default __webpack_public_path__ + "static/media/WhoPageCakeIcon.0f6896c091b3641b0743591d4b57e235.svg";
export { ForwardRef as ReactComponent };